module.exports = __webpack_public_path__ + "static/img/PU.c7ce284.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/PU.png
// module id = eyuT
// module chunks = 34